import M from "moment";
import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../modules/SimpleDDL";
import Api from "../../../Services/Api";
import {getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../common/mapper";
import BelumDelivery from "./belumDelivery/belumDelivery";
import SudahDelivery from "./sudahDelivery/sudahDelivery";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";
import {HttpStatus} from "../../common/Constants";

const FORMAT_DATE = "DD-MM-YYYY";

class DeliveryConfirmed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            submittedFilterData: {},
            filterData: {},
            searchData: {
                startDateDelivery: M(new Date()).format(FORMAT_DATE),
                endDateDelivery: M(new Date()).format(FORMAT_DATE),
            },
            kodeCabang: null,
            cabangOptions: [],
            filterVisible: false,
            loading: false,
            detailVisible: false,
            pagination: {
                totalData: 1,
                page: 1,
                limit: 5,
            },
        };
    }

    async componentDidMount() {
        this.handleTriggerLoading();
        await this.fetchDataCabang();
        this.handleTriggerLoading();
    }

    fetchDataCabang = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            menuName: "Delivery H1",
            setError: this.props.setError,
            args: null,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );

            if (filteredData.length !== 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                    cabangOptions: filteredData.map(item => mapToObjectDDL(item.namaDealer, item.kodeCabang)),
                }))
            }
            await this.fetchData({
                kodeCabang: filteredData[0]?.kodeCabang,
                ...this.state.searchData,
            });
        }
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        const userId = localStorage.getItem("userId");
        let resUser = await Api.create("NAGAMAS_MASTER_DATA").getUserProfile({
          idUser: userId,
        });
        let employeeId = resUser?.data?.data?.employeeId;

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getDeliveryData,
            menuName: "Delivery H1",
            setError: this.props.setError,
            args: {
                ...filter,
                kodeCabang: filter?.kodeCabang || this.state.kodeCabang.value,
                page: page,
                limit: limit,
                userId,
                employeeId,
                deliveryStatus: this.state.tabIndex === 1 ? "DONE" : null,
            }
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data.totalData,
                    page,
                    limit,
                },
            }));
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleSubmitFilter = async () => {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {},
            pagination: {...prevValue.pagination, totalData: 0},
        }));
        const request = removeNullFields({
            ...this.state.filterData,
            startDateDelivery: this.state.filterData?.startDateDelivery
                ? M(this.state.filterData?.startDateDelivery).format(FORMAT_DATE)
                : null,
            endDateDelivery: this.state.filterData?.endDateDelivery
                ? M(this.state.filterData?.endDateDelivery).format(FORMAT_DATE)
                : null,
            salesInvoiceDate: this.state.filterData?.salesInvoiceDate
                ? M(this.state.filterData?.salesInvoiceDate).format(FORMAT_DATE)
                : null,
            variantCode: getValueFromDDL(this.state.filterData, "variantCode"),
            idWarna: getValueFromDDL(this.state.filterData, "idWarna"),
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: false,
            submittedFilterData: request,
        }));
        this.handleTriggerLoading();
    };

    handleTabChange = async (index) => {
        this.handleTriggerLoading();
        await this.setState({
            tabIndex: index,
            filterData: {},
            searchData: {
                startDateDelivery: M(new Date()).format(FORMAT_DATE),
                endDateDelivery: M(new Date()).format(FORMAT_DATE),
            },
            submittedFilterData: {
                startDateDelivery: M(new Date()).format(FORMAT_DATE),
                endDateDelivery: M(new Date()).format(FORMAT_DATE),
            },
            pagination: {
                totalData: 0,
                page: 1,
                limit: 5,
            },
        });
        await this.fetchData(
            {
                startDateDelivery: M(new Date()).format(FORMAT_DATE),
                endDateDelivery: M(new Date()).format(FORMAT_DATE),
            },
            1,
            5,
        )
        this.handleTriggerLoading();
    };

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        await this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page,
                limit,
            },
        }));
        await this.fetchData(
            this.state.submittedFilterData,
            page,
            limit,
        );
        this.handleTriggerLoading();
    };

    handleRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        await this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: 1,
                totalData: 0,
                limit: limit,
            },
        }));
        await this.fetchData(
            this.state.submittedFilterData,
            1,
            limit,
        );
        this.handleTriggerLoading();
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleClickSearch = async (e) => {
        e.preventDefault();
        this.handleTriggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
            pagination: {...prevValue.pagination, totalData: 0},
        }));
        const request = removeNullFields({
            startDateDelivery: this.state.searchData?.startDateDelivery
                ? this.state.searchData?.startDateDelivery
                : M(new Date()).format(FORMAT_DATE),
            endDateDelivery: this.state.searchData?.endDateDelivery
                ? this.state.searchData?.endDateDelivery
                : M(new Date()).format(FORMAT_DATE),
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: request,
            submittedFilterData: request,
        }));
        this.handleTriggerLoading();
    };

    handleCabangChange = (name, value) => {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
            searchData: {
                startDateDelivery: M(new Date()).format(FORMAT_DATE),
                endDateDelivery: M(new Date()).format(FORMAT_DATE),
            },
            filterData: {},
            submittedFilterData: {
                startDateDelivery: M(new Date()).format(FORMAT_DATE),
                endDateDelivery: M(new Date()).format(FORMAT_DATE),
            },
            pagination: {...prevValue.pagination, totalData: 0},
        }),async () =>{
            await this.fetchData({
                ...this.state.searchData,
                kodeCabang: value.value,
            });
            this.handleTriggerLoading();
        });
    };

    render() {
        return (
            <>
                <Container>
                    <SimpleDDL
                        id="select_options_nama_cabang"
                        box="search"
                        name="kodeCabang"
                        containerclassname="width width-250px"
                        placeholder="Nama cabang hak akses"
                        value={this.state.kodeCabang}
                        options={this.state.cabangOptions}
                        onChange={(value, {name}) => this.handleCabangChange(name, value)}
                    />
                    <Tabs selectedIndex={this.state.tabIndex} onSelect={this.handleTabChange}>
                        <TabList>
                            <Tab>Belum Delivery</Tab>
                            <Tab>Sudah Delivery</Tab>
                        </TabList>
                        <TabPanel>
                            <BelumDelivery
                                {...this.props}
                                state={this.state}
                                refetch={this.fetchData}
                                onSearch={this.handleClickSearch}
                                onSetState={this.handleStateChange}
                                onSubmitFilter={this.handleSubmitFilter}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleRowsPerPage}
                                handleTriggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <SudahDelivery
                                {...this.props}
                                state={this.state}
                                onSearch={this.handleClickSearch}
                                onSetState={this.handleStateChange}
                                onSubmitFilter={this.handleSubmitFilter}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleRowsPerPage}
                                handleTriggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(DeliveryConfirmed);
